import React, { FC, useEffect } from "react";
import { ThemeProvider, Theme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import Loader from "@components/loader";
import useTheme from "@hooks/useTheme";
import { VenueNameEnum } from "@interfaces/enums/apiData.enum";
import { getConfigValues } from "@theme/themeConfig";

import AxiosClient from "./AxiosClient";
import useConfig from "./providers/configProvider/useConfig";
import AppRoutingModule from "./pages/AppRoutingModule";

import { clientConfig } from "./configChecker.config";

const AuthenticationChecker: FC = () => {
  const { config, activeTheme } = useConfig();
  const theme: Theme = useTheme(config?.client);
  const currentClientConfig = getConfigValues(clientConfig, config?.client);

  useEffect(() => {
    document.body.classList.toggle(
      "cgg-theme",
      config?.venueName === VenueNameEnum.cgg
    );
  }, [config]);

  useEffect(() => {
    if (currentClientConfig?.documentTitle) {
      document.title = currentClientConfig.documentTitle;
    }
  }, [currentClientConfig]);

  return !config || !activeTheme ? (
    <Loader isAbsolute isHeightFull isWidthFull />
  ) : (
    <AxiosClient>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <AppRoutingModule />
      </ThemeProvider>
    </AxiosClient>
  );
};

export default AuthenticationChecker;
